<template>
  <b-row v-if="instalados && instalados.length">
    <b-col>
      <b>MATERIALES INSTALADOS</b>
      <DxDataGrid
        :data-source="instalados"
        :show-borders="true"
        :show-column-lines="true"
        :show-row-lines="true"
        :row-alternation-enabled="true"
        :columnAutoWidth="true"
        :allow-column-resizing="true"
      >
        <DxGroupPanel
          :visible="true"
          emptyPanelText="Arrastre una columna aquí para agrupar"
        />
        <DxSearchPanel :visible="false" :width="240" placeholder="Buscar..." />
        <DxPaging :page-size="15" />
        <DxHeaderFilter :visible="true" />
        <DxFilterRow :visible="true">
          <DxOperationDescriptions
            equal="Igual a"
            notEqual="Diferente de"
            startsWith="Empieza con"
            endsWith="Termina con"
            contains="Contiene"
            between="Entre"
            notContains="No contiene"
            lessThanOrEqual="Menor o igual"
            greaterThanOrEqual="Mayor o igual"
            lessThan="Menor que"
            greaterThan="Mayor que"
          />
        </DxFilterRow>
        <DxPager
          :visible="false"
          infoText="Página {0} of {1} ({2} registros)"
          :allowed-page-sizes="pageSizes"
          display-mode="full"
          :show-page-size-selector="true"
          :show-info="true"
          :show-navigation-buttons="true"
        />
        <DxColumn data-field="cod_articulo" caption="Código" />
        <DxColumn data-field="articulo.descripcion" caption="Articulo" />
        <DxColumn data-field="cod_ucc" caption="UCC" />
        <DxColumn data-field="cantidad" caption="Cantidad" alignment="center" />
      </DxDataGrid>
    </b-col>
  </b-row>
  <b-row v-else>
    <b-col class="text-center">
      <img src="assets/img/empty.png" alt="Empty" />
      <p class="text-muted">No hay materiales instalados</p>
    </b-col>
  </b-row>
</template>
<script>
import {
  DxDataGrid,
  DxPaging,
  DxColumn,
  DxSearchPanel,
  DxFilterRow,
  DxHeaderFilter,
  DxOperationDescriptions,
  DxPager,
  DxGroupPanel,
} from "devextreme-vue/data-grid";
export default {
  components: {
    DxDataGrid,
    DxPaging,
    DxColumn,
    DxSearchPanel,
    DxFilterRow,
    DxHeaderFilter,
    DxOperationDescriptions,
    DxPager,
    DxGroupPanel,
  },
  props: {
    pageSizes: {
      type: Array,
      default: () => [5, 10, 15, 30, 50, 100],
    },
    instalados: {
      type: Array,
      default: () => [],
    },
  },
};
</script>